$(document).ready(function() {

    /************************************* PDF-DRUCK ***************************************************/
    // Auch bei Klick auf "als PDF speichern", soll das Formular abgeschickt und ein PDF generiert werden
    $('.ttgPdfText').click(function() {
        $(this).prev().trigger('click');
    });

    // Bei Hover auf den Text, soll auch das Icon als "gehovert" angezeigt werden und umgekehrt
    $(".ttgPdfText").hover(function() {
        $(this).prev().addClass("ttgPdfHover");
    }, function() {
        $(this).prev().removeClass("ttgPdfHover");
    });

    $(".ttgPdf").hover(function() {
        $(this).next().addClass("ttgIconTextHover");
    }, function() {
        $(this).next().removeClass("ttgIconTextHover");
    });

    /************************************* MERKEN-ICON ***************************************************/

    // Bei Hover auf den Text, soll auch das Icon als "gehovert" angezeigt werden und umgekehrt
    $(".ttgMerkenIconText").hover(function() {
        $(this).prev().addClass("iconMerkenSmallHover");
    }, function() {
        $(this).prev().removeClass("iconMerkenSmallHover");
    });

    $(".iconMerkenSmall").hover(function() {
        $(this).next().addClass("ttgMerkenIconTextHover");
    }, function() {
        $(this).next().removeClass("ttgMerkenIconTextHover");
    });

    /************************************* PDF-DRUCK ***************************************************/

    // bei Touren Druck noch den Maßstab auswählbar machen
    $('body').on('click', '#ttgTourScale', function() {
        if ($(this).prop('checked') === true) {
            $('.ttgTourdataPDFInfos').attr('data-tourScale', 'auto');
        } else {
            $('.ttgTourdataPDFInfos').attr('data-tourScale', 'none');
        }
    });

    // Klick auf die Checkbox
    $(".print-checkbox input[type=checkbox]").change(function() {
        if ($(this).val() == "0") {
            $(this).val("1");
            $(this).siblings('span.fa-solid').removeClass('fa-square').addClass('fa-square-check');
            if ($(this).attr('id') == "PrintMap") {
                $('.print-dropdown').show();
            }
        } else {
            $(this).val("0");
            $(this).siblings('span.fa-solid').removeClass('fa-square-check').addClass('fa-square');
            if ($(this).attr('id') == "PrintMap") {
                $('.print-dropdown').hide();
                $('#Scale').val('auto');
            }
        }
    });

    $('body').on('keydown', '.ttgCookieConsentSheet .ttgCookieType input', function(e) {
        var code = e.which;
        // 13 = Return, 32 = Space
        if ((code === 13)) {
            $(this).click();
        }
    });

    // PDF Druck aus dem Modal
    $('body').on('click', '.ttgTourdataGeneratePdfBtn', function() {

        $('.ttgTourdataGeneratePdfBtn').hide();
        $(".ttgPDFLoaderShowInfo").removeClass("ttgDisplayNone");
        trackEvent('Global', 'PDF erstellen > erstellen', $(".ttgTourdataPDFInfos").attr("data-objecttitle"));

        var season = $(".ttgTourdataPDFInfos").attr("data-season");
        if (season == "sommer") {
            season = "SUMMER";
        }
        if (season == "winter") {
            season = "WINTER";
        }
        var actLang = $(".ttgTourdataPDFInfos").attr("data-actLang");
        var tourdataExperienceId = $(".ttgTourdataPDFInfos").attr("data-tourdataExperienceId");
        var tourdataPDFLayout = $(".ttgTourdataPDFInfos").attr("data-tourdataPDFLayout");
        var tourdataSourceCategory = $(".ttgTourdataPDFInfos").attr("data-tourdataSourceCategory");
        if (tourdataSourceCategory == "POI") {
            tourdataSourceCategory = "Poi";
        }
        var tourdataSourceId = $(".ttgTourdataPDFInfos").attr("data-tourdataSourceId");
        var scale = $('.ttgTourdataPDFInfos').attr('data-tourScale');

        if (tourdataSourceCategory == "Tour") {
            scale = $('#Scale').val();
        }

        var postData;
        if (tourdataExperienceId == 0) {
            postData = 'ObjectType=' + tourdataSourceCategory + '&ObjectID=' + tourdataSourceId + '&ExperienceID=' + tourdataExperienceId + '&Language=' + actLang + '&Season=' + season + '&Scale=' + scale + '&ClearCache=0&DoPrint=0';
        } else {
            postData = 'ObjectType=' + tourdataSourceCategory + '&ObjectID=' + tourdataSourceId + '&ExperienceID=' + tourdataExperienceId + '&Language=' + actLang + '&Layout=' + tourdataPDFLayout + '&Season=' + season + '&Scale=' + scale + '&ClearCache=0&DoPrint=0';
        }

        var tourPrintParams = [
            'PrintImages',
            'PrintDescription',
            'PrintMap',
            'PrintElevation',
            'PrintSurface',
            'PrintRoute',
            'PrintOpening',
            'PrintDirections',
            'PrintContact'
        ];

        $.each(tourPrintParams, function(index, val) {
            postData += "&" + val + "=" + $('#' + val).val();
        });

        $.ajax({
            type: "POST",
            url: window.location.protocol + "//" + window.location.host + "/?type=2100",
            data: postData,
            beforeSend: function() {
                $('.ttgPDFLoadingError').remove();
            },
            success: function(result) {
                $(".ttgPDFLoaderShowInfo").addClass("ttgDisplayNone");
                var response = JSON.parse(result);
                if (response.success === true) {
                    if ($('#matomoTracking').length) {
                        //Download tracking in Matomo
                        _paq.push(['trackLink', response.pdfURL, 'download']);
                    }
                    window.open(
                        response.pdfURL,
                        '_blank'
                    );
                    trackEvent('Global', 'PDF erstellen > Download', $(".ttgTourdataPDFInfos").attr("data-objecttitle"));
                }
                if (response.success === false) {
                    $('.ttgPDFLoaderShowInfo').before("<p class='ttgPDFLoadingError'><span class='fas fa-exclamation-triangle' aria-hidden='true'></span>Fehler beim Erstellen des PDFs!</p>");
                }
            }
        });

    });


});